export default function getWantedPosition(issuePositions, ui_order_ids) {
  return ui_order_ids.reduce(
    (acc, ui_order_id) => !issuePositions[ui_order_id] && acc,
    true,
  );
}
